
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { toErrorMessage } from '@/utils/errorHandling';
import Toast from '@/utils/toast';
import StandardModal from '@/components/shared/suites/StandardModal.vue';

@Component<DeleteUserModal>({
	components: {
		StandardModal
	}
})
export default class DeleteUserModal extends Vue {
	@Action('deleteUsers', { namespace: 'users' }) private deleteUsers!: (userIds: string[]) => Promise<BulkUserActionResult | void>;
	@Prop({ type: Boolean, default: false }) private showModal!: boolean;
	@Prop({ type: Array, default: () => [] }) private userIds!: string[];

	private isSubmitting: boolean = false;
	private count: number = this.userIds.length;
	private bulkSummary: BulkUserActionResult | null = null;

	/**
	 * Delete the selected users.
	 * If bulk delete, we then show a summary. If single delete, we close the modal.
	 *
	 * @return {Promise<void>}
	 */
	private async confirm(): Promise<void> {
		this.isSubmitting = true;
		try {
			const bulkSummary = await this.deleteUsers(this.userIds);
			if (bulkSummary) {
				this.bulkSummary = bulkSummary;
				this.isSubmitting = false;
			}
			else {
				this.$emit('deleted');
			}
		}
		catch (error) {
			Toast.error(this.$tc('multi_location_settings.user_management.delete.error_deleting', this.count, { errorMessage: toErrorMessage(error) }));
			this.isSubmitting = false;
		}
	}
}
